export const whitePages = [
  '/courseDetail',
  '/paperPreview',
  '/curriculumDetail',
  '/newCurriculumDetail',
  '/resourceDetail',
  '/practiceDetail',
  '/articleDetail',
  '/newsDetail',
  '/generate-paper',
  '/boxiaoShareFrame',
]
